"use strict";


import {ComboBox} from './class.combobox.js';


window.initCombobox=(q, a,b,c)=>{
    
    return ComboBox.install(q||'.combobox', a,b,c);
    
}

ComboBox.init();

window.addEventListener('DOMContentLoaded', function() {
       
    try {
        
        VUTResizeHandler.add(ComboBox.Renderer.resize);
        
    } catch(e) {}

    try {
        ComboBox.Ajax=new window.VutRequiredLib.VutAjax(null, {preloader:false, drop_old_responses:true});
        ComboBox.Ajax.addActionHandler('combobox', ComboBox.response);
    } catch(e) {console.warn('ComboBox: chybí VutAjax!'); ComboBox.Ajax=null;}

    try {
        if (window.$&&!$().combobox) {
            ComboBox.jQ.makeJQuery();
        }
    } catch(e) {console.error(e)}
    
    initCombobox();
    
    try {window.initPopover();} catch(e) {}

});